import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  right?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
  right,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="min-w-0">
        <h4 className="flex items-center gap-2 font-heading text-lg font-600 tracking-wide text-foreground-950 md:text-xl">
          {icon && (
            <span className="flex h-6 w-6 items-center justify-center text-primary-500">
              <i className={`${icon} text-[20px]`} aria-hidden="true"></i>
            </span>
          )}
          {title}
        </h4>
        {subtitle && <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
      </div>
      {right}
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-500"
        >
          {moreLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-s-line text-[18px]" aria-hidden="true"></i>
          </span>
        </Link>
      )}
    </div>
  );
}